<template>
  <a-dialog v-model="show" width="800px" max-width="80vw" persistent scrollable>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <v-toolbar-title>
            <v-tooltip bottom :disabled="!isEllipsis(meetingObject.meetingName)">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                    {{
                    commentData && commentData.id
                      ? $t("agenda.lblUpdateComment", {title: ellipsis(meetingObject.meetingName)})
                      : $t("agenda.lblCreatComment", {title: ellipsis(meetingObject.meetingName)})
                  }}
                  </span>
              </template>
              <span>
                {{
                    commentData && commentData.id
                      ? $t("agenda.lblUpdateComment", {title: meetingObject.meetingName})
                      : $t("agenda.lblCreatComment", {title: meetingObject.meetingName})
                  }}
              </span>
            </v-tooltip>
          </v-toolbar-title>
          

          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text style="color: black">
        <v-row>
          <v-col cols="12">
            <a-rich-text-editor
              v-if="showTextEditor"
              v-model="formData.comment"
              @descriptionChange="descriptionChanges"
              required
            ></a-rich-text-editor>
            <div class="error-element" v-if="commentValidation">
              {{ commentValidation }}
            </div>
          </v-col>
          <v-col cols="12">
            <upload-file
              :files="uploadingFiles"
              :icons="fileIcons"
              :rules="rules"
              :clearList="show"
              v-on:add-files="addUploadingFiles"
              v-on:remove-file="removeUploadingFile"
              :accept="allowed_file"
              v-on:file-error="fileError"
            ></upload-file>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip
          bottom
          v-if="addMomCommentPermission || updateMomCommentPermission"
        >
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="mr-2"
              color="primaryDark"
              small
              v-bind="attrs"
              v-on="on"
              @click="saveComment"
              :disabled="
                (messageValidation !== null || errorCount > 0 || Loaderloading || isDescriptionWithImage) || !isDirtyData
              "
              v-if="addMomCommentPermission || updateMomCommentPermission"
              ><span>{{ $t("btnOk") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnOk") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              color="secondary"
              small
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnLabelCancel") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnLabelCancel") }} </span>
        </v-tooltip>
      </v-card-actions>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
      <confirm-dialog ref="confirm"></confirm-dialog>
      <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
    </v-card>
  </a-dialog>
</template>

<script>
import {
  MAX_UPLOAD_SIZE,
  allowed_file,
  fileIcons,
} from "../../../utils/constant";
import meetingService from "@/api/meetingService";
import MessageSheet from "@/components/MessageSheet.vue";
import { formatBytes, currentDateTime, createUUID } from "../../../utils/util";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import Loader from "@/components/Loader.vue";
import UploadFile from "@/components/documents/UploadFile.vue";
import { mapActions } from "vuex";
import _ from "lodash";
import InsightsMixin from "../../../mixin/InsightsMixin";

export default {
  name: "CreateMomComment",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    meetingObject: {
      type: Object,
      default: true,
    },
    commentData: {
      type: Object,
      default: null,
    },
  },
  components: {
    MessageSheet,
    ConfirmDialog,
    Loader,
    UploadFile,
  },
  mixins: [InsightsMixin],
  data() {
    return {
      isDescriptionWithImage: false,
      isPrevent: false,
      originalFormData: {},
      uploadingFiles: this.commentData
        ? _.cloneDeep(this.commentData.documents)
        : [],
      showTextEditor: false,
      formData: {
        id: this.commentData ? this.commentData.id : "",
        user_id: this.$auth.user.user_id,
        is_edited: this.commentData ? this.commentData.is_edited : false,
        meetingTypeId: this.meetingObject.meetingTypeId,
        tenantid: "",
        meetingid: this.meetingObject.id,
        comment: this.commentData ? this.commentData.comment : "",
        documents: this.commentData
          ? _.cloneDeep(this.commentData.documents)
          : [],
        createdDate:
          this.commentData && this.commentData.createdDate
            ? this.commentData.createdDate
            : new Date().toISOString(),
        updatedDate: new Date().toISOString(),
      },
      deleteDocumentIds: [],
      displayMessage: false,
      message: "",
      messageType: "",
      Loaderloading: false,
      messageValidation: null,
      commentValidation: null,
      fileIcons,
      allowed_file,
      rules: [
        (v) =>
          !v ||
          !v.some((file) => file.size > 2000000) ||
          "File size should be less than 2 MB!",
      ],
      stringLength: 50,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    addMomCommentPermission() {
      if (this.meetingObject.meetingTypeId) {
        return (
          this.$security.checkMeetingTypeAccess(
            this.meetingObject.meetingTypeId,
            "AddMomComment"
          ) && this.formData.id == ""
        );
      }
      return false;
    },
    updateMomCommentPermission() {
      if (this.meetingObject.meetingTypeId) {
        return (
          this.$security.checkMeetingTypeAccess(
            this.meetingObject.meetingTypeId,
            "UpdateMomComment"
          ) && this.formData.id != ""
        );
      }
      return false;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    errorCount() {
      let count = 0;
      for (const item of this.uploadingFiles) {
        if (this.checkStatus(item).status === false) {
          count++;
        }
      }
      return count;
    },
    isDirtyData() {
      /*console.log(
        JSON.stringify(this.originalFormData) == JSON.stringify(this.formData),
        JSON.stringify(this.originalFormData),
        JSON.stringify(this.formData)
      );*/
      const newForm = {
        ...this.formData,
        documents: this.uploadingFiles,
      };
      return JSON.stringify(this.originalFormData) !== JSON.stringify(newForm);
    },
  },
  mounted() {
    const thisInstance = this;
    this.formData.tenantid = this.selectedTenant;
    this.originalFormData = _.cloneDeep(this.formData);
    setTimeout(() => {
      thisInstance.showTextEditor = true;
    }, 200);
  },
  watch: {
    formData: {
      handler(newValue, oldValue) {
        const comment = newValue.comment;
        if (
          String(comment)
            .replace(/<(.|\n)*?>/g, "")
            .replace(/\&nbsp;/g, "")
            .trim() !== ""
        ) {
          this.messageValidation = null;
        } else {
          this.messageValidation = this.$t("reqMsgRule");
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      createDocuments: "document/createDocuments",
      deleteDocuments: "document/deleteDocuments",
      getMomComments: "meeting/getMomComments",
    }),
    ellipsis(string) {
      return  this.isEllipsis(string) ? string.substring(0, this.stringLength) + "..." : string;
    },
    isEllipsis(string) {
      return  String(string).length > this.stringLength;
    },
    descriptionChanges(val) {
      this.isDescriptionWithImage = val
    },
    close() {
      this.$emit("input", false);
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    async saveComment() {
      this.commentValidation = this.messageValidation;
      try {
        let commentId = createUUID();

        if (this.formData.id != "") {
          commentId = this.formData.id;
        }

        this.Loaderloading = true;
        await this.documentsActions(commentId);
        let response = null;
        if (this.formData.id == "") {
          this.formData.id = commentId;
          response = await meetingService.storeMomComment(this.formData);
        } else {
          this.formData.is_edited = true;
          response = await meetingService.updateMomComment(this.formData);
        }
        this.isPrevent = false;
        this.Loaderloading = false;
        this.$emit("saveComment", response);
      } catch (error) {
        this.logErrorsAndExceptions(
          "approvedList.getReviewDataSets.error",
          error
        );

        console.error(error);
        this.Loaderloading = false;
      }
    },
    getFormData(item, documentId, commentId) {
      let formData = new FormData();
      formData.append("tenantId", this.selectedTenant);
      formData.append("topicId", "");
      formData.append("documentId", documentId);
      formData.append("commentId", commentId);
      formData.append("meetingId", this.meetingObject.id);
      formData.append("agendaId", "");
      formData.append("directoryId", "");
      formData.append("peopleId", "");
      formData.append("file", item);

      formData.append("chunk_upload", false);
      formData.append("filename", item.name);
      formData.append("content_type", item.type);
      return formData;
    },
    async documentsActions(commentId) {
      if (this.deleteDocumentIds.length) {
        const promises = [];
        this.deleteDocumentIds.forEach((id) => {
          promises.push(this.deleteDocuments(id));
        });
        await Promise.all(promises);
        this.deleteDocumentIds = [];
      }

      for (const item of this.uploadingFiles) {
        if (item.documentId && item.documentId != "") {
          continue;
        }
        const documentId = createUUID();
        const formData = this.getFormData(item, documentId, commentId);
        const newDocObj = {
          documentId: documentId,
          tenantid: this.selectedTenant,
          topicId: "",
          meetingid: this.meetingObject.id,
          commentId: commentId,
          agendaid: "",
          directoryid: "",
          peopleid: "",
          name: "",
          type: "",
          size: "",
          lastModified: "",
        };
        newDocObj.name = item.name;
        newDocObj.type = item.type;
        newDocObj.size = item.size;
        newDocObj.lastModified = currentDateTime(item.lastModified);
        this.formData.documents.push(newDocObj);
        await this.createDocuments(formData);
      }
    },
    getFileIcon(filename) {
      let strArr = filename.split(".");
      let arrlength = strArr.length;
      if (arrlength > 0) {
        return fileIcons[strArr[arrlength - 1].toLowerCase()] || "mdi-file";
      }
      return "mdi-file";
    },
    fileError(err) {
      this.showMessageSheet(
        err.error + " File(s) Size Limit Exceeded",
        "error"
      );
    },
    checkStatus(file) {
      const maxSize = MAX_UPLOAD_SIZE ?? 0;
      let filesWithStatus = {
        filename: file.fileName,
      };
      if (!this.allowed_file.includes(file.type)) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileErrorMsg", {
          filename: file.fileName,
        });
      } else if (file.size > maxSize) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileSizeErrorMsg", {
          maxsize: formatBytes(maxSize),
        });
      } else {
        filesWithStatus.status = true;
        filesWithStatus.message = "Success";
      }
      return filesWithStatus;
    },
    addUploadingFiles,
    removeUploadingFile,
    scrollToBottomOfFileList
  },
};

function addUploadingFiles(files) {
  files = Array.from(files);
  this.uploadingFiles.push(...files);

  if (files.length > 0) {
    this.$nextTick(() => {
      this.scrollToBottomOfFileList();
    });
  }
}

function scrollToBottomOfFileList() {
  let attempts = 0;
  const maxAttempts = 10;

  const attemptScroll = () => {
    attempts++;

    // First try to scroll the last item into view
    const lastItems = document.querySelectorAll(
      ".file-list .v-list-item:last-child"
    );
    if (lastItems.length > 0) {
      const lastItem = lastItems[lastItems.length - 1];
      lastItem.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });

      // Additional scroll to ensure we're at the very bottom
      setTimeout(() => {
        const fileList = document.querySelector(".file-list");
        if (fileList) {
          fileList.scrollTop = fileList.scrollHeight + 100; // Add extra pixels
        }
      }, 300);
      return;
    }

    // Fallback: scroll all file-list containers to bottom
    const fileLists = document.querySelectorAll(".file-list");
    if (fileLists.length > 0) {
      fileLists.forEach((fileList) => {
        fileList.scrollTop = fileList.scrollHeight + 100; // Add extra pixels to ensure bottom
        if (fileList.scrollTo) {
          fileList.scrollTo({
            top: fileList.scrollHeight + 100,
            behavior: "smooth",
          });
        }
      });
      return;
    }

    // Retry if no elements found
    if (attempts < maxAttempts) {
      setTimeout(attemptScroll, 150);
    }
  };

  // Start attempting after a small delay
  setTimeout(attemptScroll, 100);
}

function removeUploadingFile(index) {
  const deletedFile = this.uploadingFiles[index];
  if (deletedFile.documentId && deletedFile.documentId != "") {
    this.deleteDocumentIds.push(deletedFile.documentId);
    const docIndex = this.formData.documents.findIndex(
      (doc) => doc.documentId === deletedFile.documentId
    );
    this.formData.documents.splice(docIndex, 1);
  }
  this.uploadingFiles.splice(index, 1);
}
</script>

<style scoped>
.error-element {
  color: var(--v-error-base) !important;
}
::v-deep .v-toolbar__content {
  height: 45px !important;
}
</style>